import React from "react";

export default () => (
  <div className="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
    <span className="brand">
      Dharma
    </span>
  </div>
);
